<template>
  <div class="box">
       <img src='../../../../../assets/empty/ic_wuxingxi.png'/>
       <p class="tip1">暂无数据</p>
       <!-- <p class="tip2">换筛选条件试试～</p> -->
  </div>
</template>
<script>
    export default {

    }
</script>
<style scoped  lang="less">
.box{
    text-align: center;
    margin-top:116px;
    img{
        display: inline-block;
        width:72px;
        height:64px;
    }
    .tip1{
        font-size:14px;
        color:#9B9B9B;
        margin-top:28px;

    }
    .tip2{
        font-size:14px;
        color:#9B9B9B;
        margin-top:8px;
    }
}
</style>
